import { render, staticRenderFns } from "./NewsProfile.vue?vue&type=template&id=21f4fdc8&scoped=true&"
import script from "./NewsProfile.vue?vue&type=script&lang=js&"
export * from "./NewsProfile.vue?vue&type=script&lang=js&"
import style0 from "./NewsProfile.vue?vue&type=style&index=0&id=21f4fdc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f4fdc8",
  null
  
)

export default component.exports